import React, { useState, useEffect } from 'react';
import { IoMdEye } from 'react-icons/io';
import { Button, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ViewWeightDisputes from '../../../component/b2c/models/viewWeightDisputes';
import { useMyContext } from '../../../context/MyContext';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../component/b2c/navBar/navBar';
import PaginationItem from '@mui/material/PaginationItem';
import '../../../css/custom-scrollbar.css';
import { FaWeight } from 'react-icons/fa'
import { MdCheckCircle, MdCancel } from "react-icons/md";
import axios from 'axios';
import { FaDownload } from "react-icons/fa";
import { toast } from 'react-toastify';
import { dispute_action_admin, Base_Url, weightList } from '../../../config/config';

const AllWeightDisputes = () => {
    const [totalOrders, setTotalOrders] = useState(0);
    const { isDarkMode } = useMyContext();
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const { isToggleSidebar } = useMyContext();
    const [weights, setweights] = useState([]);
    const [selectedweight, setSelectedweight] = useState(null);
    const navigate = useNavigate();

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    useEffect(() => {
        fetchAllDisputes();
    }, [page, limit]);

    // CSV Download functionality
    const downloadCSV = () => {
        if (!weights || weights.length === 0) {
            toast.error("No data available to download");
            return;
        }

        // Define CSV headers
        const headers = [
            "Seller ID",
            "Waybill",
            "Initial Weight",
            "Dimension",
            "Product Description",
            "SKU",
            "Reversed Weight",
            "Price",
            "Status",
            "Date"
        ];

        // Convert data to CSV format
        const csvData = weights.map(weight => [
            weight.seller_id || '',
            weight.waybill || '',
            weight.initial_weight || '',
            weight.dimension || '',
            weight.product_des || '',
            weight.sku || '',
            weight.reversed_weight || '',
            weight.price || '',
            weight.status || '',
            weight.timestamp || ''
        ]);

        // Add headers to the beginning
        csvData.unshift(headers);

        // Convert to CSV string
        const csvContent = csvData.map(row =>
            row.map(field => {
                // Handle fields that might contain commas or quotes
                const stringField = String(field);
                if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
                    return `"${stringField.replace(/"/g, '""')}"`;
                }
                return stringField;
            }).join(',')
        ).join('\n');

        // Create and download file
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `weight_disputes_${new Date().toISOString().split('T')[0]}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("CSV file downloaded successfully!");
    };

    const handleAccept = async (row) => {
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');
        const formData = new FormData();
        formData.append("waybill", row.waybill);
        formData.append("status", "Accept");
        formData.append("seller_id", row.seller_id);

        try {
            const response = await axios.post(Base_Url + dispute_action_admin, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'token': token,
                    'cus_id': cus_id,
                },
            });
            if (response.data.status === "SUCCESS") {
                toast.success(response.data.message);
                fetchAllDisputes(); // Refresh data after action
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error("Error uploading data: " + error.message);
        }
    };

    const handleReject = async (row) => {
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');

        const formData = new FormData();
        formData.append("waybill", row.waybill);
        formData.append("status", "Raise");
        formData.append("seller_id", row.seller_id);

        try {
            const response = await axios.post(Base_Url + dispute_action_admin, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'token': token,
                    'cus_id': cus_id,
                },
            });
            if (response.data.status === "SUCCESS") {
                toast.success(response.data.message);
                fetchAllDisputes(); // Refresh data after action
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error("Error uploading data: " + error.message);
        }
    };

    const fetchAllDisputes = async () => {
        const token = localStorage.getItem('token');
        const cusid = localStorage.getItem('cus_id');
        try {
            const pageNumber = Number(page) || 1;
            const limitNumber = Number(limit) || 10;
            const urlweight = `${Base_Url}${weightList}?page=${pageNumber}&limit=${limitNumber}`;
            const response = await fetch(urlweight, {
                method: 'GET',
                headers: {
                    token,
                    cus_id: cusid,
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status === "SUCCESS") {
                setweights(result.data);
                setTotalOrders(result.pagination.total_records);
            } else {
                toast.error(result.message || 'Failed to fetch weight disputes.');
            }
        } catch (error) {
            // toast.error('Something went wrong!');
        }
    };

    const handlePaginationChange = (event, value) => {
        setPage(value);
    };

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
        setPage(1);
    };

    const handleViewClick = (weight) => {
        setSelectedweight(weight);
        setIsPopupOpen(true);
    };

    const handleClose = () => {
        setIsPopupOpen(false);
    };

    const handleNavigation = () => {
        navigate('/dashboard');
    };

    return (
        <>
            <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-white'}`}>
                <div className="z-10 shrink-0">
                    <NavBar />
                </div>

                <div className="flex flex-1 overflow-hidden">
                    {isToggleSidebar && (
                        <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-black dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
                            style={
                                window.innerWidth < 768
                                    ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                                    : {}
                            }>
                            <Sidebar />
                        </div>
                    )}

                    {/* Main content: fixed height, only the table body scrolls */}
                    <div className={`flex flex-col bg-gray-200  w-full  border border-gray-200 p-2 overflow-hidden ${isDarkMode ? 'dark:bg-black dark:border-gray-800 text-white' : ''}`}>

                        {/* Header */}
                        <div className="flex flex-col sm:flex-row items-center gap-3 mb-3 shrink-0">
                            <button
                                onClick={handleNavigation}
                                className="text-sm w-full sm:w-auto sm:min-w-[280px] font-semibold bg-black hover:bg-gray-800 dark:bg-white dark:text-black dark:hover:bg-gray-200 text-white px-5 py-2 rounded-md h-[38px] flex items-center justify-center gap-2 transition-colors"
                            >
                                <FaWeight size={13} />
                                All Weight Disputes
                            </button>

                            <button
                                onClick={downloadCSV}
                                className="w-full sm:w-auto border border-black dark:border-white text-black dark:text-white text-sm font-medium px-4 py-2 rounded-md h-[38px] flex items-center justify-center gap-2 hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                                disabled={!weights || weights.length === 0}
                            >
                                <FaDownload size={12} />
                                Download CSV
                            </button>

                            <span className="ml-auto text-xs font-medium text-gray-500 dark:text-gray-400 whitespace-nowrap">
                                Total: {totalOrders}
                            </span>
                        </div>

                        {/* Table — only this area scrolls */}
                        <div className="flex-1 min-h-0 overflow-auto rounded-lg border border-gray-200 dark:border-gray-800 custom-scrollbar">
                            <table className="min-w-full table-auto z-[99]">
                                <thead className="bg-black text-white dark:bg-white dark:text-black text-[10px] uppercase tracking-wide sticky top-0 z-10">
                                    <tr>
                                        <th className='px-3 py-2 text-left font-semibold'>Seller ID</th>
                                        <th className='px-3 py-2 text-left font-semibold'>Waybill</th>
                                        <th className='px-3 py-2 text-left font-semibold'>Init. Wt</th>
                                        <th className='px-3 py-2 text-left font-semibold'>Dimension</th>
                                        <th className='px-3 py-2 text-left font-semibold'>Product</th>
                                        <th className='px-3 py-2 text-left font-semibold'>SKU</th>
                                        <th className='px-3 py-2 text-left font-semibold'>Rev. Wt</th>
                                        <th className='px-3 py-2 text-left font-semibold'>Price</th>
                                        <th className='px-3 py-2 text-left font-semibold'>Status</th>
                                        <th className='px-3 py-2 text-left font-semibold'>Date</th>
                                        <th className='px-3 py-2 text-left font-semibold'>Action</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                                    {weights.map((weight, index) => (
                                        <tr
                                            key={weight.id}
                                            className="hover:bg-gray-50 dark:hover:bg-gray-900 transition-colors duration-150 bg-white dark:bg-black"
                                        >
                                            <td className='px-3 py-2 text-[11px] text-gray-800 dark:text-gray-200 font-medium whitespace-nowrap'>{weight.seller_id}</td>
                                            <td className="px-3 py-2 text-[11px] text-gray-800 dark:text-gray-200 font-medium whitespace-nowrap">
                                                {weight.waybill}
                                            </td>
                                            <td className='px-3 py-2 text-[11px] text-gray-800 dark:text-gray-200 whitespace-nowrap'>{weight.initial_weight}</td>
                                            <td className='px-3 py-2 text-[11px] text-gray-800 dark:text-gray-200 whitespace-nowrap'>{weight.dimension}</td>
                                            <td className='px-3 py-2'>
                                                {weight.product_des?.length > 20 ? (
                                                    <div className="group relative">
                                                        <span className="text-[11px] text-gray-800 dark:text-gray-200 cursor-pointer">
                                                            {weight.product_des.substring(0, 20)}...
                                                        </span>
                                                        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2.5 py-1.5 bg-black text-white text-[11px] rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                                                            {weight.product_des}
                                                            <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-black"></div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <span className="text-[11px] text-gray-800 dark:text-gray-200">{weight.product_des}</span>
                                                )}
                                            </td>
                                            <td className='px-3 py-2 text-[11px] text-gray-800 dark:text-gray-200 whitespace-nowrap'>{weight.sku}</td>
                                            <td className='px-3 py-2 text-[11px] text-black dark:text-white font-semibold whitespace-nowrap'>{weight.reversed_weight}</td>
                                            <td className='px-3 py-2 text-[11px] text-black dark:text-white font-semibold whitespace-nowrap'>₹{weight.price || 'N/A'}</td>
                                            <td className='px-3 py-2'>
                                                <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold border ${weight.status === 'Accept'
                                                    ? 'border-black text-black dark:border-white dark:text-white'
                                                    : weight.status === 'Reject'
                                                        ? 'border-gray-400 text-gray-500 dark:border-gray-500 dark:text-gray-400 line-through'
                                                        : weight.status === 'close'
                                                            ? 'border-gray-300 text-gray-400 dark:border-gray-700 dark:text-gray-500'
                                                            : weight.status === 'Pending'
                                                                ? 'border-black text-black dark:border-white dark:text-white bg-gray-50 dark:bg-gray-900'
                                                                : 'border-gray-200 text-gray-500'
                                                    }`}>
                                                    <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${weight.status === 'Accept'
                                                        ? 'bg-black dark:bg-white'
                                                        : weight.status === 'Pending'
                                                            ? 'bg-black dark:bg-white animate-pulse'
                                                            : 'bg-gray-400'
                                                        }`}></span>
                                                    {weight.status}
                                                </span>
                                            </td>
                                            <td className='px-3 py-2 text-[11px] text-gray-800 dark:text-gray-200 whitespace-nowrap'>{weight.timestamp}</td>
                                            <td className='px-3 py-2'>
                                                <div className='flex items-center gap-1'>
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => handleViewClick(weight)}
                                                        className="min-w-0 p-1 rounded-md"
                                                        style={{
                                                            borderColor: '#111827',
                                                            color: '#111827',
                                                            backgroundColor: 'transparent'
                                                        }}
                                                    >
                                                        <IoMdEye className="text-xs" />
                                                    </Button>
                                                    <Button
                                                        onClick={() => handleAccept(weight)}
                                                        variant="contained"
                                                        size="small"
                                                        disabled={weight.status === "Accept" || weight.status === "close"}
                                                        className="min-w-0 p-1 rounded-md"
                                                        style={{
                                                            backgroundColor: '#111827',
                                                            color: '#ffffff'
                                                        }}
                                                    >
                                                        <MdCheckCircle className="text-xs" />
                                                    </Button>
                                                    <Button
                                                        onClick={() => handleReject(weight)}
                                                        variant="outlined"
                                                        size="small"
                                                        disabled={weight.status === "Accept" || weight.status === "close"}
                                                        className="min-w-0 p-1 rounded-md"
                                                        style={{
                                                            borderColor: '#9ca3af',
                                                            color: '#374151',
                                                            backgroundColor: 'transparent'
                                                        }}
                                                    >
                                                        <MdCancel className="text-xs" />
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Footer / Pagination — always visible, page itself never scrolls */}
                        <div className="mt-1 flex flex-col sm:flex-row justify-between items-center gap-2 shrink-0">
                            <select
                                id="limit"
                                value={limit}
                                onChange={handleLimitChange}
                                className="border border-gray-300 dark:border-gray-700 rounded-md px-2 py-1 text-xs bg-white dark:bg-black dark:text-gray-200"
                            >
                                <option value={10}>10</option>
                                <option value={15}>15</option>
                                <option value={20}>20</option>
                                <option value={totalOrders}>All</option>
                            </select>
                            <Pagination
                                count={Math.ceil(totalOrders / limit)}
                                page={page}
                                onChange={handlePaginationChange}
                                variant="outlined"
                                shape="rounded"
                                className="pagination"
                                size="small"
                                renderItem={(item) => (
                                    <PaginationItem
                                        {...item}
                                        className={`mx-0.5 rounded-md text-xs ${item.selected ? 'bg-black text-white dark:bg-white dark:text-black' : 'text-gray-700 dark:text-gray-300'} hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black`}
                                    />
                                )}
                            />
                        </div>
                    </div>
                </div>
                <ViewWeightDisputes isopen={isPopupOpen} onClose={handleClose} allWeightDisputes={selectedweight} />
            </div>
        </>
    );
};

export default AllWeightDisputes;